import CloseModal from 'actions/modal/close_modal';

export default class AddSharedSender {
  constructor(context) {
    this.context = context;
  }

  run({ address }) {
    this.context.executeAction(CloseModal);
    this.context.gateways.emailSharedSenders.add({}, { address });

    this.context.analytics.track('email shared sender - add initiated');
  }
}
